import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  try {
    const raw = localStorage.getItem("sr_act_as");
    if (raw && !config.headers["X-Act-As-Tenant"]) {
      const actAs = JSON.parse(raw);
      if (actAs?.tenant_id) config.headers["X-Act-As-Tenant"] = actAs.tenant_id;
    }
  } catch { /* ignore malformed act-as */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("tr_token");
      localStorage.removeItem("tr_user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && d && typeof d === "object" && d.code === "upgrade_required") {
      window.dispatchEvent(new CustomEvent("tr-upgrade-required", { detail: d }));
    }
    // Staff have no personal workspace — the AppShell renders an inline
    // "select a client" prompt for tenant-scoped routes, so we no longer redirect here.
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object" && d.message) return d.message;
  return fallback;
};

export const auth = {
  getUser: () => {
    try { return JSON.parse(localStorage.getItem("tr_user") || "null"); }
    catch { return null; }
  },
  getToken: () => localStorage.getItem("tr_token"),
  login: (token, user) => {
    localStorage.setItem("tr_token", token);
    localStorage.setItem("tr_user", JSON.stringify(user));
  },
  logout: () => {
    localStorage.removeItem("tr_token");
    localStorage.removeItem("tr_user");
    localStorage.removeItem("sr_act_as");
  },
};

// Staff impersonation: super_admin/admin can "act as" a client tenant so every
// SmartReach call is scoped to that client (via the X-Act-As-Tenant header above).
export const actAs = {
  get: () => {
    try { return JSON.parse(localStorage.getItem("sr_act_as") || "null"); }
    catch { return null; }
  },
  set: (tenant_id, name) => {
    localStorage.setItem("sr_act_as", JSON.stringify({ tenant_id, name }));
  },
  clear: () => localStorage.removeItem("sr_act_as"),
};
